export const i18nAssetPage = {
  sections: {
    alarms_list: 'Histórico de alarmes',
    event_list: 'Histórico de eventos',
  },
  components: {
    upload_assets_tree: 'Nenhum ativo registrado. Comece a criar sua árvore de ativos.',
    add_asset: 'Adicionar ativo',
    upload_csv: 'Enviar CSV',
    upload_tags: 'Enviar tags em CSV',
  },
  message: {
    asset_not_found: {
      title: 'Equipamento não encontrado',
      message: 'Por favor tente com um id de equipamento válido',
    },
    generic_error: {
      title: 'Ops..',
      message: 'Ocorreu um erro inesperado. Aguarde alguns minutos e tente novamente',
    },
  },
};
